import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '@geely/ui';

interface MaskedEmailInputProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
}

export function MaskedEmailInput({ value, onChange, name }: MaskedEmailInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    { mask: /^\S*$/, prepare: (str: string) => str.toLowerCase() },
    { onAccept: (maskedValue: string) => onChange(maskedValue) }
  );

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value, setValue]);

  return (
    <Input
      ref={ref}
      id={name}
      type="email"
      placeholder="seu@email.com"
    />
  );
}
